var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequirements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 49.5,
    y1: 404.5,
    x2: 85.5,
    y2: 440.5,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad",
    id: "fill0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#73B4C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1747,
    stopColor: "#6AAEC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4567,
    stopColor: "#529EB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    stopColor: "#2C839F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#147391"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-44 -393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.2 404.5C73.4 403.5 74.2 401.8 74.2 400 74.2 396.3 71.2 393.5 67.6 393.5 64 393.5 61 396.2 61 399.9 61 401.8 61.8 403.5 63 404.5L49.5 404.5 49.5 418.2C50.7 417 52.4 416.2 54.2 416.2 57.9 416.2 60.8 419.2 60.8 422.8 60.8 426.4 57.8 429.4 54.2 429.4 52.3 429.4 50.7 428.6 49.5 427.4L49.5 440.4 85.5 440.4 85.5 404.4 72.2 404.4Z",
    stroke: "#464646",
    strokeMiterlimit: 10,
    fill: "url(#fill0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequirements);
export default __webpack_public_path__ + "static/media/Requirements.6a2f116b31ec2c5857622d31e39d7341.svg";
export { ForwardRef as ReactComponent };